module.exports = __webpack_public_path__ + "assets/media/mobile-illustration.89ab8c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoSuccessStep/mobile-illustration.png
// module id = 3079
// module chunks = 0